import { Col } from "react-bootstrap";
import useTranslator from "../../hooks/useTranslator";
import backicon from "../../assets/img/back.png";
import moment from "moment";
import { haveValue, isObject } from "../../helper/common";
import { Row } from "react-bootstrap";
import DefaulterCheckTable from "./DefaulterCheckTable";

const DefaulterCheck = (props) => {
  const { _t } = useTranslator();
  const { user, setShowExperianDetails } = props;
  const experianData =
    user?.tenant_extra_field_id?.experianJson?.["s:Envelope"]?.["s:Body"]
      ?.GenerarInformeResponse?.GenerarInformeResult?.InformeDelphi4A3;
  const badexcugData = user?.tenant_extra_field_id?.experianJson?.badexcug;

  const getBarWidth = (start, end) => {
    let score =
      experianData?.InformacionDelphi?.ProbabilidadIncumplimientoPorScore;
    if (score <= start) return "0%";
    if (score >= end) return "100%";
    return `${((score - start) / (end - start)) * 100}%`;
  };

  const getTextColor = (value) => {
    if (value < 25) return "text-filler-dark-green";
    if (value < 50) return "text-filler-light-green";
    if (value < 75) return "text-filler-yellow";
    return "text-filler-orange";
  };

  return (
    <>
      <div className="primaryaccordion border-pd d-block">
        <Row className=" accordion-item">
          <div className="d-flex justify-content-center position relative">
            <a
              href={undefined}
              className="dark-green-text position-absolute start-0 d-flex justify-content-center align-items-center gap-1"
              style={{ flexShrink: 0 }}
              onClick={(e) => setShowExperianDetails(false)}
            >
              <img style={{ height: "0.97vw" }} src={backicon} alt="" />
              <span>{_t("goBack")}</span>
            </a>
            <h2>
              <span>{_t("defaulterChecks")}</span>
            </h2>
          </div>

          <Col xl={6} className="box-content-area">
            <div className="rank-box">
              <span
                className={`rank-grade ${getTextColor(
                  experianData?.InformacionDelphi
                    ?.ProbabilidadIncumplimientoPorScore
                )}`}
              >
                {experianData?.InformacionDelphi?.Nota}
              </span>
              {_t("rank")}
            </div>
            <div className="d-flex justify-content-between align-items-center">
              <span className="score-progress-head">{_t("probImpago")}</span>
              <span
                className={`score-progress-score ${getTextColor(
                  experianData?.InformacionDelphi
                    ?.ProbabilidadIncumplimientoPorScore
                )}`}
              >
                {
                  experianData?.InformacionDelphi
                    ?.ProbabilidadIncumplimientoPorScore
                }
                %
              </span>
            </div>
            <div class="progress-bar-inner-wrapper pdf-score-capsule">
              <div class="d-flex gap-2">
                <p class="progress-step">
                  <span
                    class="progress-fill progress-filler-dark-green"
                    style={{
                      width: getBarWidth(0, 25),
                    }}
                  ></span>
                </p>
                <p class="progress-step">
                  <span
                    class="progress-fill progress-filler-light-green"
                    style={{
                      width: getBarWidth(25, 50),
                    }}
                  ></span>
                </p>

                <p class="progress-step rotate-180">
                  <span
                    class="progress-fill progress-filler-yellow"
                    style={{
                      width: getBarWidth(50, 75),
                    }}
                  ></span>
                </p>

                <p class="progress-step">
                  <span
                    class="progress-fill progress-filler-orange"
                    style={{
                      width: getBarWidth(75, 100),
                    }}
                  ></span>
                </p>
              </div>
              <div class="d-flex justify-content-between">
                <span class="score-limit">0%</span>
                <span class="score-limit">100%</span>
              </div>
            </div>
            <div className="dd grey-box-content bg-light-grey">
              <div className="d-flex items-start justify-content-between grey-box-point">
                <p className="grey-box-heading d-flex align-items-start gap-1">
                  <span>
                    {_t("dniNie")}
                    {": "}{" "}
                  </span>
                  <span className="date d-inline-block grey-box-val">
                    {user?.dni_nie}
                  </span>
                </p>
              </div>
              <div className="d-flex items-start justify-content-between grey-box-point">
                <p className="grey-box-heading d-flex align-items-start gap-1">
                  <span>
                    {_t("age")}
                    {": "}{" "}
                  </span>
                  <span className="date d-inline-block grey-box-val">
                    {moment().diff(moment(user?.dob), "years")}
                  </span>
                </p>
              </div>
              <div className="d-flex items-start justify-content-between grey-box-point">
                <p className="grey-box-heading d-flex align-items-start gap-1">
                  <span>
                    {_t("currentPostcode")}
                    {": "}{" "}
                  </span>
                  <span className="date d-inline-block grey-box-val">
                    {user?.post_code}
                  </span>
                </p>
              </div>
              <div className="d-flex items-start justify-content-between grey-box-point">
                <p className="grey-box-heading d-flex align-items-start gap-1">
                  <span>
                    {_t("nationality")}
                    {": "}{" "}
                  </span>
                  <span className="date d-inline-block grey-box-val">
                    {experianData?.Documento?.PaisDocumento?.Descripcion}
                  </span>
                </p>
              </div>
              <div className="d-flex items-start justify-content-between grey-box-point">
                <p className="grey-box-heading d-flex align-items-start gap-1">
                  <span>
                    {_t("experianComments")}
                    {": "}{" "}
                  </span>
                  <span className="date d-inline-block grey-box-val">
                    {experianData?.OrigenScore?.Descripcion}
                  </span>
                </p>
              </div>
            </div>
          </Col>
          <Col
            xl={6}
            className="profile-summary right-box gap-16 padding-3 border-pd h-auto"
          >
            {haveValue(experianData?.ResumenCais) &&
              Object.keys(experianData.ResumenCais).map((key) => {
                if (
                  key == "NumeroOperacionesImpagadas" ||
                  key == "NumeroCuotasImpagadas" ||
                  key == "ImporteImpagado" ||
                  key == "MaximoImporteImpagado"
                ) {
                  return (
                    <p className=" right-list-item">
                      <span className="rounded-check">
                        {_t(key.toLowerCase())}:{" "}
                      </span>
                      <span className="date d-inline-block right-box-val">
                        {experianData.ResumenCais[key]}
                      </span>
                      <img
                        src="/images/tick-new.svg"
                        alt=""
                        className="green-check-icon"
                      />
                    </p>
                  );
                } else {
                  if (
                    Number(
                      experianData.ResumenCais.NumeroOperacionesImpagadas
                    ) > 0 ||
                    Number(experianData.ResumenCais.NumeroCuotasImpagadas) > 0
                  ) {
                    return (
                      <p className="  right-list-item">
                        <span className="rounded-check">
                          {_t(key.toLowerCase())}:{" "}
                        </span>
                        <span className="date d-inline-block right-box-val ">
                          {isObject(experianData.ResumenCais[key])
                            ? `${experianData.ResumenCais[key].DD}/${experianData.ResumenCais[key].MM}/${experianData.ResumenCais[key].AAAA}`
                            : experianData.ResumenCais[key]}
                        </span>
                        <img
                          src="/images/tick-new.svg"
                          alt=""
                          className="green-check-icon"
                        />
                      </p>
                    );
                  }
                }
              })}
          </Col>
        </Row>
        <div className="border-top my-3"></div>
        {haveValue(badexcugData) &&
          Array.isArray(badexcugData) &&
          badexcugData.length > 0 && (
            <Row>
              <h5>
                {_t(
                  "detalleBadexcug",
                  "Field used in the defaulter check page"
                )}
              </h5>
              <DefaulterCheckTable defaulterData={badexcugData ?? []} />
            </Row>
          )}
      </div>
    </>
  );
};

export default DefaulterCheck;
